module.exports = __webpack_public_path__ + "assets/img/deviceOnline.e2cf6a37.png";